module.exports = __webpack_public_path__ + "img/missionaries29_2019_7-7-2021.ba6c1288.jpg";